<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
  >

    <v-layout wrap>
      <v-flex
        sm6
        xs12
        md6
        lg4
      >
        <!--<material-stats-card
          :value="contatori.npurchases || '0'"
          :title="$store.state.labels.current_lan.db_numero_acquisti"
          color="#004876"
          icon="mdi-content-copy"
          small-value="pieces"
          sub-icon="mdi-alert"
          sub-icon-color="error"
          sub-text="missing payment..."
          sub-text-color="text-primary"
        />-->
        <material-stats-card
          :value="contatori.npurchases || '0'"
          :title="$store.state.labels.current_lan.db_numero_acquisti"
          color="#004876"
          img="images/acquisti.jpg"
          small-value="pieces"
          @click="vaia('tool-kind')"

        />
      </v-flex>
      <v-flex
        sm6
        xs12
        md6
        lg4
      >
        <material-stats-card
          :value="cliente.nlogins || '0'"
          :title="$store.state.labels.current_lan.db_numero_visite"
          color="#004876"
          img="images/visite.jpg"

        />
      </v-flex>

      <v-flex
        sm6
        xs12
        md6
        lg4
      >
        <material-stats-card
          :value="contatori.ntoolsinorder+''|| '0'"
          :title="$store.state.labels.current_lan.db_numero_pezzi_in_ordine"
          color="#004876"
          img="images/ordinati.jpg"
          @click="vaia('serial-number-list')"
        />
      </v-flex>
      <v-flex
        sm6
        xs12
        md6
        lg4
      >
        <material-stats-card
          :value="contatori.ntoolsinservice+''|| '0'"
          :title="$store.state.labels.current_lan.db_numero_pezzi_in_service"
          color="#004876"
          img="images/manute.jpg"
          @click="vaia('serial-number-list')"
        />
      </v-flex>
      <v-flex
        sm6
        xs12
        md6
        lg4
      >
        <material-stats-card
          :value="contatori.ntoolsinserviceyear+''|| '0'"
          :title="$store.state.labels.current_lan.db_numero_pezzi_in_service_anno"
          color="#004876"
          img="images/manutanno.jpg"
          @click="vaia('serial-number-list')"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

export default {
  data () {
    return {
    }
  },
  computed: {
    cliente () {
      return this.$store.state.clientecorrente
    },
    contatori () {
      return this.$store.state.cliente.data.articoli.contatori
      /* console.log('ottengo contatori', this.$store.state.clientecorrente)
      let c = {}
      if (this.$store.state.clientecorrente.articoli && this.$store.state.clientecorrente.articoli.contatori) {
        c = this.$store.state.clientecorrente.articoli.contatori
      }
      return c
      */

    }
  },
  mounted () {
    // this.$store.dispatch('getCliente', '10119')
    console.log('AAAAA')
  },
  methods: {
    vaia (to) {
      console.log(to, this.$router)
      this.$router.push(to)

    }
  }
}
</script>
